import { useState } from 'react';
//import Video from '../../videos/video.mp4';
import imgHome from '../../assets/img2.jpg'
import { CoverContainer, CoverBg, VideoBg, CoverContent, CoverH1, CoverP, CoverBtnWrapper, ArrowForward, ArrowRight } from './styles.js';
import { Button } from '../ButtonElements.js';

import { NavBtnLink } from '../Navbar/styles.js'

export function CoverSection() {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };

  //src={Video}

  return (
    <CoverContainer>
      <CoverBg>
        <VideoBg autoPlay loop muted src={imgHome} type='img' />
      </CoverBg>
      <CoverContent>
        <CoverH1>A melhor em concursos Publicos</CoverH1>
        <CoverP>Tnha sua aprovação mais rapida com a melhor plataforma de questões</CoverP>
        <CoverBtnWrapper>
          <NavBtnLink to='/login'>
            Garanta sua vaga
          </NavBtnLink>
          {/* <Button to='/login' onMouseEnter={onHover} onMouseLeave={onHover} primary='true' dark='true'>
                    Publicar Projeto {hover ? <ArrowForward /> : <ArrowRight />}
                </Button> */}
        </CoverBtnWrapper>

      </CoverContent>
    </CoverContainer>
  )
}